import client from '@/shared/apis/client'

import { type PatientBackgroundPayload } from '../types/embed'

// 頭書き(ホスト薬歴の患者基本確認)の受領。薬歴 1 件につき 1 レコードの冪等 upsert。
//
// 生成のたびに渡すのではなく back に保存するのは、front を経由しない SOAP 生成経路が
// あるため(後追い文字起こし完了後のサーバ側再生成)。詳細は back 側 view の docstring。
export const putPatientBackground = async (
  yakurekiId: string,
  payload: PatientBackgroundPayload
): Promise<void> => {
  await client.put(
    `/api/anycompass/events/${yakurekiId}/patient-background/`,
    payload
  )
}
